import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PATH } from '../../../assets/constants';
import { AuthenticationService } from '../services/authentication.service';
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  standalone: true,
  styleUrls: ['./bottom-navigation.component.scss'],
  imports: [
    MatIcon,
    MatIconButton
  ]
})
export class BottomNavigationComponent {
  private authService = inject(AuthenticationService);
  private router = inject(Router);


  id: string;



  constructor() {
    this.id = this.authService.getIdFromAccessToken();
  }

  navigateToMain(): void {
    this.router.navigate( [ PATH.MAIN ]  );
  }

  navigateToMyProfile() {
    this.router.navigate( [ PATH.PROFIL, this.id ] );
  }

  navigateToMyBookings() {
    this.router.navigate( [ PATH.BOOKINGS, this.id ] );
  }

  navigateToMySessions() {
    this.router.navigate( [ PATH.SESSIONS, this.id ] );
  }

  navigateToMessages() {
    this.router.navigate( [ PATH.CHAT, this.id ] );
  }

}
